import React from 'react';
import Layout from '../components/layout';
import './contact.css';

export default function ContactPage() {
  return (
    <Layout subtitle="Contact" className="smart-power smart-power-theater">
      <h1 style={{ marginBottom: '1rem' }}>Contact Us</h1>
      <p>
        If you have any questions regarding our products or services, please
        contact us by phone or by the form below. We look forward to hearing
        from you.
      </p>
      <address>
        Benjamin Smart Power
        <br />
        by Benjamin Electric Co.
        <br />
        1615 Staunton Ave
        <br />
        Los Angeles, CA 90021-3118
        <br />
        Phone: (213) 749-7731
      </address>
      <form method="post" action="/contact.php">
        <label htmlFor="name">Name</label>
        <input id="name" name="name" placeholder="Type Here" required="" />

        <label htmlFor="phone">Phone</label>
        <input id="phone" name="phone" placeholder="Type Here" />

        <label htmlFor="email">Email</label>
        <input
          id="email"
          name="email"
          type="email"
          placeholder="Type Here"
          required=""
        />

        <label htmlFor="subject">Subject</label>
        <input
          id="subject"
          name="subject"
          placeholder="Type Here"
          required=""
        />

        <label htmlFor="message">Message</label>
        <textarea
          id="message"
          name="message"
          placeholder="Type Here"
          required=""
        ></textarea>

        <label htmlFor="message">*What is 2+2? (Anti-spam)</label>
        <input id="message" name="human" placeholder="Type Here" required="" />

        <input name="site" type="hidden" value="benjaminsmartpower.com" />

        <input id="submit" name="submit" type="submit" value="Submit" />
      </form>
    </Layout>
  );
}
